// extracted by mini-css-extract-plugin
export var slide = "slide-module--slide--13Cuq";
export var slide_foto = "slide-module--slide_foto--3PHLo";
export var slide_content = "slide-module--slide_content--1L0vI";
export var slide_content_top = "slide-module--slide_content_top--1Padz";
export var slide_content_text = "slide-module--slide_content_text--17_U-";